import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { GstError, Invoice } from '../../../../models/invoice.interface';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { FinanceApiService } from '../../../../services/finance-a-p-iervice.service';
import { LoadingService } from '../../../../services/loading.service';
import { ToasterService } from '../../../../services/toaster.service';

@Component({
  selector: 'app-irn-gen-error',
  standalone: true,
  imports: [SvgIconComponent, SharedModule],
  templateUrl: './irn-gen-error.component.html',
  styleUrl: './irn-gen-error.component.scss'
})
export class IrnGenErrorComponent {
    @Input() invoice!: Invoice;
    @Input() enableRetry: boolean = true;

    constructor(private financeAPI: FinanceApiService,
      private loadingService: LoadingService,
      private toasterService: ToasterService
    ) {

    }

    get errorLogs() {
        return this.invoice?.irnDetails?.errors?.map((error: GstError) => error.msg) || [];
    }

    retryIrnGeneration(): void {
      this.loadingService.show();
      this.financeAPI.generateIRNForInvoice(this.invoice.id).subscribe({
        next: (response) => {
          this.loadingService.hide();
          this.toasterService.success("IRN retry in progress. Please verify status later.");
          this.enableRetry = false;
        }, 
        error: (error) => {
          console.error("Error while retrying IRN generation: ", error);
          this.loadingService.hide();
          this.toasterService.error("Error while retrying IRN generation");
        }
      });
    }
}
